export const FigureList = ({ children }) => {
  return <ul className="flex flex-row space-x-9">{children}</ul>
}
